import { UseQueryResult, skipToken } from '@tanstack/react-query'
import { uniswapUrls } from 'uniswap/src/constants/urls'
import { useQueryWithImmediateGarbageCollection } from 'uniswap/src/data/apiClients/hooks/useQueryWithImmediateGarbageCollection'
import { 
  TRADING_API_CACHE_KEY, 
  fetchPools, 
  PoolsRequest, 
  PoolsResponse 
} from 'uniswap/src/data/apiClients/tradingApi/TradingApiClient'
import { UseQueryWithImmediateGarbageCollectionApiHelperHookArgs } from 'uniswap/src/data/apiClients/types'

export function useTradingApiPoolsQuery({
  params,
  ...rest
}: UseQueryWithImmediateGarbageCollectionApiHelperHookArgs<
  PoolsRequest,
  PoolsResponse
>): UseQueryResult<PoolsResponse> {
  const queryKey = [TRADING_API_CACHE_KEY, uniswapUrls.tradingApiPaths.pools, params]

  return useQueryWithImmediateGarbageCollection<PoolsResponse>({
    queryKey,
    queryFn: params
      ? async (): ReturnType<typeof fetchPools> => {
          try {
            const result = await fetchPools(params)
            return result
          } catch (error) {
            console.error('🔍 [useTradingApiPoolsQuery] fetchPools error:', error)
            throw error
          }
        }
      : skipToken,
    ...rest,
  })
}
